import type { ClientError } from 'graphql-request';

type PortalOperationContext = {
  operation: string;
  url: string;
};

export class PortalOperationError extends Error {
  constructor(clientError: ClientError, context: PortalOperationContext) {
    const prefix = `GraphQL error for operation "${context.operation}":`;

    const headers = clientError.response['headers'] as Headers;
    const xServerHeader = headers.get('x-server');
    if (xServerHeader !== 'code-pushup-api') {
      super(
        [
          `${prefix} It appears that the upload server "${context.url}" is invalid, it should be the URL of the portal's GraphQL API ("https://<self-hosted-code-pushup-api>/graphql").`,
          `All responses from the Code PushUp Portal API should have the "x-server" header set to "code-pushup-api",`,
          xServerHeader
            ? `but this header is set to "${xServerHeader}"`
            : 'but this header is missing.',
          `The response's status code is ${clientError.response.status} and the Content-Type is ${headers.get('content-type') || 'unknown'}.`,
        ].join(' '),
      );
      return;
    }

    const formattedErrors = clientError.response.errors?.map(
      ({ message, extensions, path }) => {
        const additional = [
          ...(typeof extensions['code'] === 'string'
            ? [`code: ${extensions['code']}`]
            : []),
          ...(path?.length ? [`path: ${path.join('.')}`] : []),
        ];
        if (additional.length > 0) {
          return `${message} [${additional.join('; ')}]`;
        }
        return message;
      },
    );

    super(`${prefix} ${formattedErrors?.join('\n') || clientError.message}`);
  }
}
